import { MenuItem } from "@mui/material";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type AlignImageFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const AlignImageField = (props: AlignImageFieldProps) => {
  return (
    <EditorVisualTextField
      select
      label="Align"
      size="small"
      fullWidth
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    >
      <MenuItem value="left">Left</MenuItem>
      <MenuItem value="center">Center</MenuItem>
      <MenuItem value="right">Right</MenuItem>
      <MenuItem value="fill">Fill</MenuItem>
    </EditorVisualTextField>
  );
};

export default AlignImageField;
